import axios from "axios";
import API_URL from './apiBase';

const portalAxiosInstance = axios.create({ baseURL: API_URL });

// Attach portal token to every request
portalAxiosInstance.interceptors.request.use((config) => {
    const portalToken = localStorage.getItem("PORTAL_TOKEN");
    if (portalToken) {
        config.headers.Authorization = `Bearer ${portalToken}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

portalAxiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            const status = error.response.status;
            const errData = error.response.data;

            // Redirect on 401 or token-expired error code
            if (status === 401 || errData?.code === 10900) {
                console.warn("Portal session expired, redirecting to portal login...");
                localStorage.removeItem("PORTAL_TOKEN");
                localStorage.removeItem("PORTAL_CUSTOMER_NAME");
                localStorage.removeItem("PORTAL_CLIENT_NAME");
                window.location.href = "/portal/login";
            }
        }
        return Promise.reject(error);
    }
);

export default portalAxiosInstance;
